var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFboSubCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0.000244141C4.48571 0.000244141 0 4.48596 0 10.0002C0 15.5145 4.48571 20.0002 10 20.0002C15.5143 20.0002 20 15.5145 20 10.0002C20 4.48596 15.5143 0.000244141 10 0.000244141ZM10 18.2574C5.44762 18.2574 1.74286 14.5526 1.74286 10.0002C1.74286 5.44786 5.44762 1.7431 10 1.7431C14.5524 1.7431 18.2571 5.44786 18.2571 10.0002C18.2571 14.5526 14.5524 18.2574 10 18.2574Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9047 9.13361H6.08568C5.84372 9.13361 5.64758 9.35869 5.64758 9.63634V10.6309C5.64758 10.9085 5.84372 11.1336 6.08568 11.1336H13.9047C14.1467 11.1336 14.3428 10.9085 14.3428 10.6309V9.63634C14.3428 9.35869 14.1467 9.13361 13.9047 9.13361Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFboSubCircle);
export default __webpack_public_path__ + "static/media/FBOSubCircle.c304a33d51013057181fb4b4840cffbb.svg";
export { ForwardRef as ReactComponent };